const revenueByService = (revenues: any) => {
  let data: any = [];
  const result = revenues.filter(
    (revenue: any) => revenue._id === "SERVICE"
  )[0];
  const service = result === undefined ? [] : result;

  service?.list?.forEach((serv: any) => {
    serv?.list?.forEach((item: any) => {
      data.push(item);
    });
  });

  return { service, data };
};

export default revenueByService;
